import { APP_PLATFORM, APP } from 'libs/constants';
import apiCall from './apiRequest';
import endPoints from './endpoints';
import config from 'config';

const { API } = config;

export function getSubscriptionPortalApi() {
  return apiCall({
    method: 'post',
    url: `${API.fastApi}/${endPoints.subscriptionPortal}`
  });
}

export function getUserSubscriptionsApi() {
  return apiCall({
    method: 'get',
    url: `${API.fastApi}/${endPoints.me.subscriptions}`
  });
}



// WEBPACK FOOTER //
// ./src/api/subscriptions.js